import { render, staticRenderFns } from "./PostServiceComponent.vue?vue&type=template&id=01e9b4b4"
import script from "./PostServiceComponent.vue?vue&type=script&lang=js"
export * from "./PostServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports